if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = Array.from(this.querySelectorAll('[data-tab-target]'));
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(tab));
        });
      }

      select(selectedTab) {
        const targetId = selectedTab.getAttribute('data-tab-target');

        this.tabs.forEach((tab) => {
          const isActive = tab === selectedTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.querySelectorAll('.product-tabs__panel').forEach((panel) => {
          panel.classList.toggle('is-active', panel.id === targetId);
        });
      }
    }
  );
}
